import React from "react";
import { useForm, Controller } from "react-hook-form";

import {
  Grid,
  Paper,
  Typography,
  IconButton,
  CardContent,
  CardActions,
  Button,
  MenuItem,
  Input,
  FormControl,
  Select,
  InputLabel,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import clientCategories from "../../../../../utils/client.categories.json";

export const AdvanceSearch = (props) => {
  const { classes, handleToggle, handleSearch } = props;
  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
  });

  const onSubmit = (data) => {
    const query = `${data.companyName ? `&companyName=${encodeURIComponent(data.companyName)}` : ""}${
      data.category ? `&category=${encodeURIComponent(data.category)}` : ""
    }`;

    handleSearch(query);
  };

  const handleChange = (e, targetName) => {
    console.log(e);
    setValue(
      targetName ? targetName : e.target.name,
      (e && e.target && e.target.value) || e,
      { shouldDirty: true },
    );
  };

  return (
    <React.Fragment>
      <Paper className={classes.advanceCard} elevation={3}>
        <form onSubmit={(e) => e.preventDefault()}>
          <CardContent>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="flex-end"
            >
              <IconButton
                aria-label="close"
                size="small"
                onClick={handleToggle}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <Grid
              container
              direction="column"
              justify="flex-start"
              alignItems="flex-start"
              spacing={2}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    gutterBottom
                    style={{
                      color: "#757575",
                      fontWeight: 600,
                    }}
                  >
                    Company Name
                  </Typography>

                  <Input
                    fullWidth
                    placeholder="Enter company name"
                    name="companyName"
                    inputRef={register}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    gutterBottom
                    style={{
                      color: "#757575",
                      fontWeight: 600,
                    }}
                  >
                    Category
                  </Typography>

                  <FormControl variant="outlined" size="small" fullWidth>
                    <Controller
                      as={
                        <Select displayEmpty>
                          <MenuItem value="">
                            <em>All Categories</em>
                          </MenuItem>
                          {clientCategories.map((category, index) => (
                            <MenuItem key={index} value={category}>
                              {category}
                            </MenuItem>
                          ))}
                        </Select>
                      }
                      control={control}
                      name="category"
                      defaultValue=""
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="flex-end"
              style={{ marginTop: "12px" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit(onSubmit)}
              >
                Search
              </Button>
            </Grid>
          </CardActions>
        </form>
      </Paper>
    </React.Fragment>
  );
};
